import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { NgxUiLoaderService } from "ngx-ui-loader";

@Injectable({ providedIn: 'root' })
export class GeneralService {
    constructor(private http: HttpClient, private notificationService: NotificationService,
        private loaderService: NgxUiLoaderService) {
    }

    getData(Ruta: any, loader:boolean=true) {
        if(loader)this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.get(Ruta).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, false);
                    if(loader)this.loaderService.stop();
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    if(loader)this.loaderService.stop();
                    reject(error);
                });
        });
    }

    getParamsData(Ruta: any, Params: any, notifyError: boolean = true, loading = true, ) {
      if(loading)this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.get(Ruta, { params: Params }).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, false);
                 if(loading) this.loaderService.stop();
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    this.notificationService.error(error);
                  if(loading)this.loaderService.stop();
                    reject(error);
                });
        });
    }

    getDataById(ruta: any, id: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.get(ruta + "/" + id).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, false);
                    this.loaderService.stop();
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    CreateOrUpdateData(ruta: any, body: any, method: any, loader:boolean=true) {
        if(loader)this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http[method]<any>(ruta, body).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    if(loader)this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    if(loader)this.loaderService.stop();
                    reject(error);
                });
        });
    }

    postFomData(path: any, file: File, fields: any, notifyError: boolean = true, loading = true) {
        if (loading) { this.loaderService.start(); }
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            Object.keys(fields).forEach(key => {
                formData.append(key, fields[key]);
            });
            formData.append('file', file);
            const headers = new HttpHeaders({ 'provider': "AWS" });
            this.http.post(path, formData, { headers }).subscribe(
                (response: any) => {
                    const success = this.notificationService.verifyStatus(response, false);
                    if (loading) { this.loaderService.stop(); }
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if (loading) { this.loaderService.stop(); }
                    reject(error);
                });
        });
    }


    CreateOrUpdateDataResponse(ruta: any, body: any, method: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http[method]<any>(ruta, body).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve({ success: success, data: response.data ? response.data : null, estado: response.estado ? response.estado : null });
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    patchData(ruta: any, body: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http['patch']<any>(ruta, body).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    putData(ruta: any, body: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.put(ruta, body).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    deleteData(ruta: any, id: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.delete(ruta + '/' + id).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    deleteDataParams(ruta: any, params: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.delete(ruta, { params }).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }
    deleteWithoutId(ruta: any) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.delete(ruta).subscribe(
                (response: any) => {
                    let success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    this.notificationService.error(error);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    convertDateToString(fecha: Date) {
        return fecha.toISOString().split('T')[0];
    }

}